export default __webpack_public_path__ + "static/media/AVATAR.d9d76e66.png";